import $ from 'jquery'
import template from 'lodash.template'
import formatDate from '../../utils/dateFns/format'
import AjaxList from '../../components/ajaxList'
import i18n from '../../utils/translate'
import { localeDate } from '../../utils/date'
import { format } from '../../utils/currency'

class Module {
  constructor ($module) {
    this.$module = $module
    this.$container = $module.find('.js-invoices_list')
    this.$list = $module.find('.js-invoices_wrap')
    this.$templateEl = $module.find('.js-invoices_template')

    this.template = template(this.$templateEl.html())
    this.list = new AjaxList({
      $container: this.$container,
      $form: $module.find('.js-invoices_filter_form'),
      append: (response, replace) => {
        this.append(response, replace)
      }
    })
  }

  append (response, replace) {
    if (replace) {
      this.$list.empty()
    }

    if (!response.invoices.length) {
      this.$container.addClass('empty_list')
    } else {
      this.$container.removeClass('empty_list')

      let content = ''
      let prevDate = replace ? null : $.trim(this.$container.find('.b-networks__subtitle:last').text())
      let date = null
      let row = null

      response.invoices.forEach((v, index) => {
        date = localeDate(v.created_at)
        row = this.render(v, date !== prevDate ? date : null)

        content += row
        prevDate = date
      })

      this.$list.append(content)
    }
  }

  render (value, date) {
    const id = value.invoice_number ? i18n.gettext('invoice.title_id', value.invoice_number) : i18n.gettext('invoice.title_new')
    const createdAt = formatDate(value.created_at, 'dd.mm.yyyy')
    const title = i18n.gettext('invoice.title', id, createdAt)

    return this.template({
      id: value.id,
      title: title,
      date: date,
      amount: format(value.amount, value.currency),
      status: i18n.gettext('invoice.status.' + value.status),
      document: value.document && value.document.path,
      url: this.$templateEl.data('invoice-url').replace(/_id_/, value.id)
    })
  }
}

$(function () {
  $('.js-invoices').each(function () {
    new Module($(this))
  })
})
